import { useEffect } from "react";

/*
In production, a reverse proxy server directs all requests for /api and /auth to
the backend service. In development and testing, without a reverse proxy server,
Google authentication redirects user to /auth/google/callback with some query
parameters, so we redirect the user to the backend with the same query parameters
to complete the authentication.
*/

const LoginFromGoogleRedirectToBackend = () => {

  useEffect(() => {
    const redirectURL = `${process.env.REACT_APP_API_BASE}/auth/google/callback${window.location.search}`;
    window.location.href = redirectURL;
  }, []);

  return (
        <div className="loadingcenter">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/loading.gif"}
            alt=""
          />
        </div>
  );
};

export default LoginFromGoogleRedirectToBackend;
